var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpinionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/\xEC\xA0\x9C\xEC\x95\x88\xC2\xB7\xEC\x8B\xA0\xEA\xB3\xA0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C9.23858 4 7 6.23858 7 9V15H17V9C17 6.23858 14.7614 4 12 4ZM18 18V16H6V18H18Z",
    fill: "#43494F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpinionIcon);
export default __webpack_public_path__ + "static/media/opinion-icon.2f7568c1fbe7d763453f47d24873dda9.svg";
export { ForwardRef as ReactComponent };